export const pageTypeTranslation = {
  question: 'Pergunta',
  media: 'Mídia',
  offer: 'Oferta',
  video: 'Vídeo',
  functionality: 'Funcionalidade',
  specialist: 'Atendimento especialista',
  release: 'Lançamento',
};
